export var AiUseCaseSchema;
(function (AiUseCaseSchema) {
    AiUseCaseSchema["PLAUSIBILITY"] = "plausibility";
    AiUseCaseSchema["VALXML_EXTRACTOR"] = "valxml_extractor";
    AiUseCaseSchema["LAND_REGISTRY"] = "land_registry";
    AiUseCaseSchema["ENERGY_CERTIFICATE"] = "energy_certificate";
    AiUseCaseSchema["SMART_PDF_IMPORT"] = "smart_pdf_import";
    AiUseCaseSchema["TENANT_IMPORT"] = "tenant_import";
})(AiUseCaseSchema || (AiUseCaseSchema = {}));
